import { render, staticRenderFns } from "./Creditor.vue?vue&type=template&id=259ae8be"
import script from "./Creditor.vue?vue&type=script&lang=ts"
export * from "./Creditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports